// extracted by mini-css-extract-plugin
export default {"Tab":"index_Tab__27seR","activeTab":"index_activeTab__3pt4D"};